import { autoinject } from "aurelia-framework";
import { Claims } from "../../../../../../constants/authentication/claims";
import { RuleDisplayResultHelper } from "../../../../../../helpers/rule-display-result-helper";
import { DynamicColumnModel, EntityDynamicValue } from "../../../../../../models/basics/basics.models";
import { GetCapResponse, GetListItemResponse } from "../../../../../../models/lists/list.models";
import { DataType } from "../../../../../../models/queries/queries.models";
import { RuleDisplayResultSection } from "../../../../../../models/rules/rules.models";
import { VetClientModel } from "../../../../../../models/vetting/vetting.models";
import { UserClaimsService } from "../../../../../../services/authentication/user-claims.service";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { CustomerService } from "../../../../../../services/modules/customer-client.service";

@autoinject
export class AdditionalInformationDialog {

    listData: GetListItemResponse[];
    cap: GetCapResponse;
    sire: boolean = false;
    task: { canViewDisplayResultsInOverview: boolean, vetTaskId: number };
    vet: VetClientModel;
    displaySections: RuleDisplayResultSection[];

    isRightShipUser: boolean;

    constructor(private dialogClientService: DialogClientService,
        private customerService: CustomerService,
        private userClaimService: UserClaimsService) {
        this.isRightShipUser = this.userClaimService.hasPermission(Claims.RightShipUser);
    }

    closeDialog() {
        this.dialogClientService.hide();
    }

    activate(model: {
        listItems: GetListItemResponse[],
        cap: GetCapResponse,
        task: { canViewDisplayResultsInOverview: boolean, vetTaskId: number },
        vet: VetClientModel

    }) {
        this.listData = model.listItems;
        this.cap = model.cap;
        this.task = model.task;
        this.vet = model.vet;

        if (this.task.canViewDisplayResultsInOverview) {
            this.customerService.getDisplayResultJson(this.task.vetTaskId).then(displayResultJson => {
                const displaySections: RuleDisplayResultSection[] = displayResultJson ? JSON.parse(displayResultJson).sections : [];

                displaySections.forEach(section => {
                    section.items.forEach(item => {
                        item.text = RuleDisplayResultHelper.beatifyResultHtml(item, this.isRightShipUser);
                    });
                });

                this.displaySections = displaySections;
                this.sire = this.displaySections.filter(x => x.items.filter(y => y.uri.toLowerCase() == "vettingrulesires").length > 0).length > 0;
            });
        }
    }

    displayName(dynamicColumns: DynamicColumnModel[], entityDynamicValue: EntityDynamicValue) {
        const column = dynamicColumns.filter(x => x.columnId == entityDynamicValue.columnId)[0];
        return column.displayName;
    }

    isTextBox(dynamicColumns: DynamicColumnModel[], entityDynamicValue: EntityDynamicValue) {
        const column = dynamicColumns.filter(x => x.columnId == entityDynamicValue.columnId)[0];
        return column.tableColumnDataTypeId == DataType.Default ||
            column.tableColumnDataTypeId == DataType.Number ||
            column.tableColumnDataTypeId == DataType.Double;
    }

    getTextBoxType(dynamicColumns: DynamicColumnModel[], entityDynamicValue: EntityDynamicValue) {
        const column = dynamicColumns.filter(x => x.columnId == entityDynamicValue.columnId)[0];
        if (column.tableColumnDataTypeId == DataType.Default) {
            return "text";
        }
        if (column.tableColumnDataTypeId == DataType.Number) {
            return "integer";
        }
        if (column.tableColumnDataTypeId == DataType.Double) {
            return "double";
        }
    }

    isCheckbox(dynamicColumns: DynamicColumnModel[], entityDynamicValue: EntityDynamicValue) {
        const column = dynamicColumns.filter(x => x.columnId == entityDynamicValue.columnId)[0];
        return column.tableColumnDataTypeId == DataType.Boolean;
    }

    isDate(dynamicColumns: DynamicColumnModel[], entityDynamicValue: EntityDynamicValue) {
        const column = dynamicColumns.filter(x => x.columnId == entityDynamicValue.columnId)[0];
        return column.tableColumnDataTypeId == DataType.DateTime;
    }
}